export const urlBase = process.env.REACT_APP_API;

export const userCredentials = () => {
  const credentials = localStorage.getItem('credentials');
  if (credentials) {
    return JSON.parse(credentials);
  }
  return { token: 'default' };
};
